import styled, { css } from 'styled-components';

import InputComponent from '../../ui/Form/Input';
import SelectComponent from '../../ui/Form/Select';
import LabelComponent from '../../ui/Form/Label';
import TitleComponent from '../../ui/Title';

export const cssInput = css`
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  border: 0;
  border-radius: 0.25rem;
  width: 100%;

`;

export const FormGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.375rem;
`;

export const FormGroupItem = styled.div`
  flex: 1;
  margin-bottom: 1.25rem;
  min-width: 0;
  padding: 0 0.375rem;
`;

export const Input = styled(InputComponent)`
  ${cssInput}
`;

export const Select = styled(SelectComponent)`
  ${cssInput}
`;

export const Title = styled(TitleComponent)`
  color: ${({ theme }) => theme.COLOR_WHITE};
`;

export const Label = styled(LabelComponent)`
  color: ${({ theme }) => theme.COLOR_WHITE};
  padding: 0 0 0.5rem;
`;
